export default __webpack_public_path__ + "static/media/icon_5_1.dbe135c2.svg";